<template>
    <div ref="root">
        <slot/>
    </div>
</template>

<script>
    export default {
        name: "ScrollEmitter",

        mounted() {
            this.$refs.root.addEventListener('scroll', this.emit)
        },

        beforeDestroy() {
            this.$refs.root.removeEventListener('scroll', this.emit)
        },

        methods: {
            emit(event) {
                this.$emit('scroll', event)
            }
        }
    }
</script>